module cr.events {
    export class EventFormController {
        static $inject = [ '$scope' ];

        constructor(private $scope)
        {
            $scope.SetEvent=(event)=>{
                console.log("we select event: "+angular.toJson(event));
                //$state.go("^.results.my",{bib: data.Bib });
                this.$scope.$parent.value=event;
            }

        }
    }

    eventModule.controller('eventFormController', EventFormController);

}
